<template>
  <div class="modal is-active">
    <div class="modal-background" />
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Delete Draft
        </p>
        <button
          id="modal-close-btn"
          type="button"
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        />
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12">
            <div v-html="message[userType]" />
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          id="modal-delete-btn"
          type="button"
          class="button is-danger"
          :class="isDeleting ? 'is-loading' : ''"
          :disabled="isDeleting"
          @click="deleteDraft"
        >
          Delete
        </button>
        <button
          id="modal-cancel-btn"
          type="button"
          class="button is-dark"
          @click="$emit('close')"
        >
          Cancel
        </button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DeleteDraft',
  props: {
    filingId: {
      type: Number,
      default: 0,
      required: true,
    },
    userType: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      isDeleting: false,
      message: {
        self: 'WARNING: This will delete all of the work you have completed so far on this filing.  Click \'<b>Delete</b>\' to proceed or click <b>Cancel</b> to stop.',
        temp: 'WARNING: This action will delete all of the work this user has done for this filing.  Only delete the draft if you plan to upload a paper filing for this year. Click <b>OK</b> to proceed or click <b>Cancel</b>.',
      },
    };
  },
  methods: {
    deleteDraft () {
      this.isDeleting = true;
      this.$store.dispatch('filing/deleteFilingDraft', this.filingId).then(() => {
        this.$store.dispatch('filings/fetchUserFilings', this.userType === 'temp' ? this.$store.state.user.tempId : null).then(() => {
          this.isDeleting = false;
          this.$success('Draft deleted');
          this.$emit('close');
        });
      });
    },
  },
};
</script>